import Link from "next/link";
import { Tiktok } from "react-bootstrap-icons";

type SocialItem = {
  id: number;
  icon?: string;
  link?: string;
  customIcon?: React.ReactNode;
  name?: string;
};

const Social = () => {
  const socialContent: SocialItem[] = [
    {
      id: 1,
      icon: "icon-facebook",
      link: process.env.NEXT_PUBLIC_FACEBOOK,
      name: "Facebook"
    },
    {
      id: 2,
      icon: "icon-instagram",
      link: process.env.NEXT_PUBLIC_INSTAGRAM,
      name: "Instagram"
    },
    {
      id: 3,
      icon: "icon-linkedin",
      link: process.env.NEXT_PUBLIC_LINKEDIN,
      name: "LinkedIn"
    },
    {
      id: 4,
      link: process.env.NEXT_PUBLIC_TIKTOK,
      customIcon: <Tiktok className="text-14" title={"TikTok"} />,
      name: "TikTok"
    },
  ];

  return (
    <>
      {socialContent
        .filter((item) => Boolean(item?.link)) // ✅ prevent invalid href
        .map((item) => (
          <Link
            key={item?.id}
            href={item?.link!}
            target="_blank"
            rel="noopener noreferrer"
            title={item?.name}
          >
            {item.customIcon ? (
              item.customIcon
            ) : (
              <i className={`${item.icon} text-14`} title={item?.name} />
            )}
          </Link>
        ))}
    </>
  );
};

export default Social;
